// import icons
import highestRes from "../../pages/Home/page-assets/highestRes.svg";
import foliage from "../../pages/Home/page-assets/foliagePenetration.svg";
import ground from "../../pages/Home/page-assets/groundPenetration.svg";
import allWeather from "../../pages/Home/page-assets/allWeather.svg";
import platforms from "../../pages/Home/page-assets/wideRangePlatforms.svg";

const HOME_CONSTANTS = {
  BANNER: {
    VIDEO:
      `https://sisir-website-assets.s3.ap-south-1.amazonaws.com/Home/home-banner-vid.mp4`,
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-banner-image.webp`,
    IMG_LANDSCAPE: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-banner-img-landscape.webp`,
    ALT: "Sisir Radar Satellite SAR Image",
    HEADERS: ["Disrupting SAR", "Delivering Unmatched", "Insights"],
    SUBHEADER: [
      "Spearheading a new era in Earth observation with the world’s highest resolution L & P Band SAR. From spaceborne to airborne platforms, our next-generation systems deliver 24/7, all-weather situational awareness—empowering critical decisions anytime, anywhere.",
    ],
  },
  USP: {
    BG: "",
    CONTENT: [
      {
        ICON: highestRes,
        NAME: "Highest Resolution L & P Band SAR"
      },
      {
        ICON: foliage,
        NAME: "Foliage Penetration"
      },
      {
        ICON: ground,
        NAME: "Ground penetration"
      },
      {
        ICON: allWeather,
        NAME: "24/7, All-Weather Monitoring"
      },
      {
        ICON: platforms,
        NAME: "Adaptable to a Wide Range of Platforms"
      }
    ]
  },
  LARGE_LABEL: {
    HEADER: "Designed, Engineered and Built in India",
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-large-label-bg.webp`,
    ALT: "Synthetic Aperture Radar Image"
  },
  TECHNOLOGY: {
    HEADER: "Technology Solutions We Offer",
    TECHS: [
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-sar.webp`,
        ALT: "Synthetic Aperture Radar Image",
        TITLE: "SYNTHETIC APERTURE RADAR",
        TEXTS: [
          "Sisir Radar offers advanced SAR systems for terrestrial, aerial and space platforms across the P, L and X bands. It provides all-weather, 24/7 monitoring with unmatched deployment flexibility, delivering time-sensitive, high resolution situational awareness for both strategic and commercial applications. Our L and P band SAR systems can see through tree cover and even the ground from space."
        ],
        LINK: "technology/sar",
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-gpr.webp`,
        ALT: "Ground Penetrating Radar Image",
        TITLE: "GROUND PENETRATING RADAR",
        TEXTS: [
          "Sisir Radar’s rugged and ultra high bandwidth GPR systems can be mounted on drones, UGVs, or handheld form factors. We offer exceptional depth penetration and precise subsurface imaging, which are ideal for IED detection, mineral exploration, archaeological surveys and infrastructure monitoring.",
        ],
        LINK: "technology/gpr",
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-hyperspec.webp`,
        ALT: "Hyperspectral Imaging Image",
        TITLE: "HYPERSPECTRAL IMAGING",
        TEXTS: [
          "Sisir Radar has developed a drone-based Hyperspectral Imaging System that uses custom analysis algorithms to rapidly process data across 50+ spectral bands. This innovative approach coupled with our intuitive HS analysis software accelerates analysis, providing actionable insights for agriculture, environmental monitoring and mineral identification.",
        ],
        LINK: "technology/hyperspectral",
      },
    ],
  },
  APPLICATIONS: {
    HEADER: "USE CASES",
    CONTENT: [
      {
        NAME: "DEFENCE",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-defence.webp`,
        ALT: "Defence use case image",
        LINK: "use-cases#defence",
      },
      {
        NAME: "AGRICULTURE",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-agriculture.webp`,
        ALT: "Agriculture use case image",
        LINK: "use-cases#agriculture",
      },
      {
        NAME: "MINING",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-mining.webp`,
        ALT: "Mining use case image",
        LINK: "use-cases#mining",
      },
      {
        NAME: "URBAN PLANNING",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-urban-planning.webp`,
        ALT: "Urban Planning use case image",
        LINK: "use-cases#urban-planning",
      },
      {
        NAME: "ENVIRONMENT",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-environment.webp`,
        ALT: "Environment use case image",
        LINK: "use-cases#environment",
      },
    ],
  },
  MESSAGE: {
    BG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/Vijayawada.webp`,
    HEADER: "FOUNDER'S INSIGHT",
    SUBTITLE:
      "Our founder, Dr. Tapan Misra, is one of the world’s foremost experts in the field of SAR and the brains behind ISRO’s first SAR satellite mission RISAT.",
    VIDEO:
      `https://sisir-website-assets.s3.ap-south-1.amazonaws.com/Home/home-founder-message.mp4`,
    POSTER:
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/founder-message-thumbnail.webp`,
    SOCIALS: {
      LINKEDIN: "https://in.linkedin.com/in/tapan-misra-2a6ba85",
      WIKIPEDIA: "https://en.wikipedia.org/wiki/Tapan_Misra",
    },
  },
  PARTNERS: {
    HEADER: "PARTNERS",
    LOGOS: [
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/ministry-of-defence.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/drdo.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/indian-air-force.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/nibe.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/astra-microwave-products.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/bharat-electronics.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/ashok-leyland.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/hindustan_zinc.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/vedanta.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/cassiopiea.png`,

      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/idex.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/forge.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/in-space.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/indian-space-association.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/geospatial.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/3rd-i-tech.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/karman.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/IIT_Kharagpur_Logo.png`,
      `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/PartnersNew/kmda.png`,
    ],
  },

  // Changing highlight cards with new one
  HIGHLIGHTS: {
    BG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/home-highlights-bg.webp`,
    ALT: "Sisir Radar Highlights Image",
    HEADER: "HIGHLIGHTS",
    CONTENT: [
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/sisir_radar_hosts.webp`,
        ALT: "X-Band SAR Image",
        TEXTS: [
          "Sisir Radar Hosts Dr. V. Narayanan, Secretary, DOS and Chairman, ISRO",
        ],
        DATE: "Aug 20, 2025",
        LINK: "https://www.sisirradar.com/blog/blog_94"
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/wire_fencing.webp`,
        ALT: "Nibe Space Image",
        TEXTS: [
          "L Band SAR Reveals Wire Fencing Invisible to Optical Imagery",
        ],
        DATE: "Sep 4, 2025",
        LINK: "https://www.sisirradar.com/blog/blog_98"
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/foliage_penetration.webp`,
        ALT: "CIO Image",
        TEXTS: [
          "Understanding Foliage Penetration in SAR: Insights from P and L Band Imaging",
        ],
        DATE: "Sep 1, 2025",
        LINK: "https://www.sisirradar.com/blog/blog_97"
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Home/idex-award.webp`,
        ALT: "IDEX Award Image",
        TEXTS: [
          "Sisir Radar is the Proud Winner of the IDEX Challenge for Developing SAR Satellite Payloads for the Indian Air Force",
        ],
        DATE: "Oct 10, 2023",
        LINK: "https://www.sisirradar.com/blog/blog_25"
      },
    ],
  },
};

export default HOME_CONSTANTS;
